import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';

// Displays the password validation text.
@Component({
  selector: 'app-password-validator',
  templateUrl: './password-validator.component.html',
  styleUrls: ['./password-validator.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PasswordValidatorComponent implements OnInit, OnChanges {
  constructor() {}

  @Input() password: string = '';
  @Input() passwordConfirm: string = '';

  @Output() passwordValidationErrors = new EventEmitter<{
    error:
      | 'passwordLength'
      | 'passwordUppercase'
      | 'passwordLowercase'
      | 'passwordSpecialCharacter'
      | 'passwordNumber'
      | 'passwordMatch';
  } | null>();

  validatePasswordLength() {
    return this.password.length >= 8;
  }

  validatePasswordContainsUppercase() {
    return /[A-Z]/.test(this.password);
  }

  validatePasswordContainsLowercase() {
    return /[a-z]/.test(this.password);
  }

  validatePasswordContainsSpecialCharacter() {
    return /[!@#$%^&*]/.test(this.password);
  }

  validatePasswordContainsNumber() {
    return /[\d]/.test(this.password);
  }

  validatePasswordsMatch() {
    return (
      this.password &&
      this.passwordConfirm &&
      this.password === this.passwordConfirm
    );
  }

  validatePassword() {
    if (!this.validatePasswordLength()) {
      return this.passwordValidationErrors.emit({ error: 'passwordLength' });
    }

    if (!this.validatePasswordContainsUppercase()) {
      return this.passwordValidationErrors.emit({ error: 'passwordUppercase' });
    }

    if (!this.validatePasswordContainsLowercase()) {
      return this.passwordValidationErrors.emit({ error: 'passwordLowercase' });
    }

    if (!this.validatePasswordContainsSpecialCharacter()) {
      return this.passwordValidationErrors.emit({
        error: 'passwordSpecialCharacter'
      });
    }

    if (!this.validatePasswordContainsNumber()) {
      return this.passwordValidationErrors.emit({ error: 'passwordNumber' });
    }

    if (!this.validatePasswordsMatch()) {
      return this.passwordValidationErrors.emit({ error: 'passwordMatch' });
    }

    return this.passwordValidationErrors.emit(null);
  }

  ngOnChanges(SimpleChanges: SimpleChanges): void {
    const { password, passwordConfirm } = SimpleChanges;

    if (password || passwordConfirm) {
      this.validatePassword();
    }
  }

  ngOnInit(): void {}
}
